import script from "./TemplateA.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateA.vue?vue&type=script&setup=true&lang=js"

import "./TemplateA.vue?vue&type=style&index=0&id=48478492&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48478492"]])

export default __exports__